import React, { useState } from 'react';

const WhichCameFirstQuestion = ({ events, onCorrect, onWrong }) => {
  const [selected, setSelected] = useState(null);
  const [eventA, eventB] = events;

  const handleChoice = (choiceIndex) => {
    if (selected !== null) return;
    setSelected(choiceIndex);
    const correctIndex = eventA.year <= eventB.year ? 0 : 1;
    if (choiceIndex === correctIndex) {
      onCorrect();
    } else {
      onWrong();
    }
  };

  return (
    <div className="text-center">
      <h3 className="text-lg font-bold text-blue-300 mb-4">Which Event Happened First?</h3>
      <div className="flex flex-col md:flex-row gap-6 justify-center">
        {[eventA, eventB].map((event, idx) => (
          <button
            key={idx}
            onClick={() => handleChoice(idx)}
            disabled={selected !== null}
            className="bg-gray-800 hover:bg-purple-700 text-white px-6 py-3 rounded-lg font-semibold transition"
          >
            {event.title}
          </button>
        ))}
      </div>
    </div>
  );
};

export default WhichCameFirstQuestion;
